import { Injectable, Inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { Observable } from 'rxjs';
import { IndirectType } from './IndirectType';

@Injectable({
    providedIn: 'root'
})
export class IndirectLaborTypesLookupService {
    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(LoggingService) private log: LoggingService
    ) {}

    private url = `${environment.apiLocation}/IndirectType/Labor`;
    public getIndirectTypes(): Observable<Array<IndirectType>> {
        return this.http.get<Array<IndirectType>>(this.url).pipe(res => {
            this.log.verbose({
                type:
                    'IndirectLaborTypesLookupService:getIndirectLaborTypes:reponse',
                res
            });
            return res;
        });
    }
}
